import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Tenure from './tenure';
import TenureDetail from './tenure-detail';
import TenureUpdate from './tenure-update';
import TenureDeleteDialog from './tenure-delete-dialog';

const TenureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Tenure />} />
    <Route path="new" element={<TenureUpdate />} />
    <Route path=":id">
      <Route index element={<TenureDetail />} />
      <Route path="edit" element={<TenureUpdate />} />
      <Route path="delete" element={<TenureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenureRoutes;
